export default __webpack_public_path__ + "static/media/floorrock-ap-rockwool-komposition_comp.8466dbed.jpg";